import { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AccountSettings } from '../components/AccountSettings';
import { PrivacySettings } from '../components/PrivacySettings';
import { NotificationSettings } from '../components/NotificationSettings';
import { DataExportSettings } from '../components/DataExportSettings';

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  if (value !== index) return null;
  return (
    <Box role="tabpanel" sx={{ py: 3 }}>
      {children}
    </Box>
  );
}

export function SettingsPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Configuracoes
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          aria-label="Configuracoes"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Conta" />
          <Tab label="Privacidade" />
          <Tab label="Notificacoes" />
          <Tab label="Dados" />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <AccountSettings />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <PrivacySettings />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <NotificationSettings />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <DataExportSettings />
      </TabPanel>
    </Container>
  );
}
